module.exports = __webpack_public_path__ + "img/Background2.e273a9cf.png";